module.exports = __webpack_public_path__ + "static/media/gif.df6ddbeb.gif";